<app-navbar/>
<main class="navbar-content">
  <router-outlet />
</main>